<template>
  <div>
    <Homepage />
  </div>
</template>
<script>
import Homepage from "@/components/Homepage";
export default {
  components: {
    Homepage,
  },
  created() {
    if (localStorage.getItem("usersarabanleeng") === null) {
      this.$router.push("/manageform1").catch(() => {});
    }
  },
};
</script>
